__turbopack_context__.v({
  "date": "home-sport-game-top-module-sass-module__Z3ccKq__date",
  "flagTop": "home-sport-game-top-module-sass-module__Z3ccKq__flagTop",
  "homeGameItemMarket": "home-sport-game-top-module-sass-module__Z3ccKq__homeGameItemMarket",
  "internationalDate": "home-sport-game-top-module-sass-module__Z3ccKq__internationalDate",
  "internationalName": "home-sport-game-top-module-sass-module__Z3ccKq__internationalName",
  "internationalTeam": "home-sport-game-top-module-sass-module__Z3ccKq__internationalTeam",
  "name": "home-sport-game-top-module-sass-module__Z3ccKq__name",
  "scoreboardLink": "home-sport-game-top-module-sass-module__Z3ccKq__scoreboardLink",
  "scoreboardTop": "home-sport-game-top-module-sass-module__Z3ccKq__scoreboardTop",
  "scoreboardTopInternational": "home-sport-game-top-module-sass-module__Z3ccKq__scoreboardTopInternational",
  "star": "home-sport-game-top-module-sass-module__Z3ccKq__star",
  "starAnimation": "home-sport-game-top-module-sass-module__Z3ccKq__starAnimation",
  "starred": "home-sport-game-top-module-sass-module__Z3ccKq__starred",
  "starredAnimation": "home-sport-game-top-module-sass-module__Z3ccKq__starredAnimation",
  "team": "home-sport-game-top-module-sass-module__Z3ccKq__team",
  "topGameItem": "home-sport-game-top-module-sass-module__Z3ccKq__topGameItem",
});
